import React, { useEffect, useState } from 'react'
import './daterange_style.css'
import moment from 'moment'
import 'antd/dist/antd.css'
import { Checkbox, DatePicker } from 'antd';

interface DateRangeProps {
    filter_obj: any,
    dateFilter: any,
    setDateFilter: any,
    type:any
}

const { RangePicker } = DatePicker;

const DateRange: React.FC<DateRangeProps> = ({ filter_obj, dateFilter, setDateFilter, type }) => {

    const [rangeStartDate, setRangeStartDate] = useState<any>("");
    const [rangeEndDate, setRangeEndDate] = useState<any>("");
    const [startDateFilter, setStartDateFilter] = useState<any>()
    const [endDateFilter, setEndDateFilter] = useState<any>()
    const [months, setMonths] = useState<any>("")
    const [first_load, setFirst_load] = useState<any>(false);
    const [contractVlaue, setContractValue] = useState<any>(filter_obj['Current_contract'])

    const handleDateChange = (values: any) => {
        if (!values) {
            return;
        }
        setRangeStartDate(moment(values[0]?._d)?.format('YYYY-MM-DD'));
        setRangeEndDate(moment(values[1]?._d)?.format('YYYY-MM-DD'));
        let startDate: any = moment(values[0]).format('YYYY-MM-DD');
        let endDate: any = moment(values[1]).format('YYYY-MM-DD');
        Object.assign(filter_obj, { 'No_of_months': false, 'Current_contract': false, 'start_date': startDate, 'end_date': endDate })
        setContractValue(false)

    }

    useEffect(() => {
        setMonths(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type])

    return (
        <div className="dateRange">
            <div style={{ marginRight: "1.5rem", marginBottom: "1rem" }}>
                <select name="" id="" className="form-control total_symbol" onChange={(e) => {
                    setDateFilter(e.target.value)
                }}>
                    <option value="Current_contract" className='total_symbol' selected={dateFilter === 'Current_contract'}>Current Contract</option>
                    <option value="custom_dateRange" className="total_symbol" selected={dateFilter === 'custom_dateRange'}>Date range</option>
                    <option value="no_of_months" className="total_symbol" selected={dateFilter === 'no_of_months'}>No of months</option>
                </select>
            </div>
            <div>
                {dateFilter === 'Current_contract' ?
                    <div className="Current_contract_row" >
                        <input type='checkbox'
                            checked={contractVlaue}
                            onChange={() => {
                                Object.assign(filter_obj, { 'No_of_months': false, 'Current_contract': true, 'start_date': false, 'end_date': false })
                                setContractValue(filter_obj['Current_contract'])
                            }}
                        />
                        Current contract selected
                    </div>
                    : dateFilter === 'custom_dateRange' ?
                        <div className="d-flex">
                            <div >
                                <RangePicker
                                    format="DD MMM YYYY"
                                    className='range_pick_calende_chart'
                                    onChange={(values: any) => {
                                        handleDateChange(values)
                                    }}
                                    disabledDate={(current: any) => {
                                        let customDate = moment().format("YYYY-MM-DD");
                                        return (
                                            current && current >= moment(customDate, "YYYY-MM-DD")
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        : dateFilter === 'no_of_months' ?
                            <select name="" id="" className="form-control total_symbol" onChange={(e) => {
                                setMonths(e.target.value);
                                Object.assign(filter_obj, { 'No_of_months': e.target.value, 'Current_contract': false, 'start_date': false, 'end_date': false })
                                setContractValue(filter_obj['No_of_months'] === false && filter_obj['start_date'] === false)
                                setFirst_load(true)
                                setStartDateFilter("");
                                setEndDateFilter("");
                            }}>

                                <option value="" selected={filter_obj['No_of_months'] === ""}>Select month</option>
                                <option value="6" selected={filter_obj['No_of_months'] === '6'} >6 Months</option>
                                <option value="12" selected={filter_obj['No_of_months'] === '12'}>12 Months</option>
                                <option value="24" selected={filter_obj['No_of_months'] === '24'}>24 Months</option>
                                <option value="36" selected={filter_obj['No_of_months'] === '36'}>36 Months</option>
                                <option value="48" selected={filter_obj['No_of_months'] === '48'}>48 Months</option>
                                <option value="60" selected={filter_obj['No_of_months'] === '60'}>60 Months</option>
                            </select>
                            : ""
                }
            </div>
        </div>
    )
}

export default DateRange